import React from 'react';
import {
  Card, CardContent, Typography, Avatar, Box, Button
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';
import EventIcon from '@mui/icons-material/Event';
import '../../Recruteur/Dashboard/MissionsList.css'; 

const CandidaturesList = ({ candidatures = [], onView = () => {} }) => {
  const lastCandidatures = candidatures.slice(0, 4);

  return (
    <div className="missions-list-compact">
      {lastCandidatures.map((c, i) => (
        <Card key={i} className="mission-compact-card" elevation={1}>
          <CardContent className="mission-compact-content">
            <Avatar className="mission-compact-avatar">
              <PersonIcon />
            </Avatar>

            <Box className="mission-compact-info">
              <Typography variant="subtitle1" className="mission-title" noWrap>
              {c.reference || 'N/A'}
              </Typography>


              <Box className="company-row">
                <WorkIcon fontSize="small" className="icon-small" />
                <Typography variant="subtitle2" className="company-name" noWrap>
                  {c.missionTitre || 'Mission inconnue'}
                </Typography>
              </Box>

              <Box className="meta-row">
                <EventIcon fontSize="small" className="icon-small" />
                <Typography variant="caption" className="meta-text" noWrap>

                {c.dateCandidature && !isNaN(new Date(c.dateCandidature)) ?
                new Date(c.dateCandidature).toLocaleString() :
                '—'}
                </Typography>
              </Box>

              <Typography variant="body2" sx={{ color: '#5a6478', fontStyle: 'italic' }}>
                Statut : {c.statut}
              </Typography>
            </Box>

            <Box className="prime-and-btn">
              <Button
                variant="outlined"
                size="small"
                className="details-btn"
                onClick={() => onView(c._id || c.idCandidature)}
                >
                Détails
              </Button>
            </Box>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default CandidaturesList;
